// React imports
import { useEffect, useRef, useState } from "react";
import Image from 'react-bootstrap/Image';
// OpenLayers imports
import { Feature, Map } from "ol";
import "ol/ol.css";
import TileLayer from "ol/layer/Tile";
import View from "ol/View";
import { TileJSON, Vector } from "ol/source";
import { fromLonLat, transform } from "ol/proj";
import { Point } from "ol/geom";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import mapIcon from "../images/icon_circle.png";
import VectorLayer from "ol/layer/Vector";
import Attribution from 'ol/control/Attribution';
import { defaults as defaultControls } from 'ol/control/defaults';

// Bootstrap imports
import Modal from "react-bootstrap/Modal";

// firebase imports
import {
    getFirestore,
    collection,
    getDocs,
    query,
} from "firebase/firestore";
import { app } from "../firebase/firebase";

function OlMap({ latitude, longitude }) {

    const mapRef = useRef(null);

    // show/hide Modal or Toast with poem details
    const [show, setShow] = useState(false);

    // set content for Modal
    const [poemFeatures, setFeatures] = useState([]);

    useEffect(() => {

        // Maptiler stuff
        const key = 'DQMIhlZ3iOPdmlZ7Uhj1';

        const source = new TileJSON({
            url: "https://api.maptiler.com/tiles/2236c292-6b79-4b96-8c43-0fe20927eae9/tiles.json?key=" + key, // source URL
            tileSize: 512,
            crossOrigin: 'anonymous'
        });

        const myAttribution = new Attribution({
            label: "(c)",
            attributions: ["Karte: Württembergische Landesbibliothek Stuttgart, 1Cg/221", `<a href="https://www.maptiler.com/engine/">Rendered with MapTiler Engine</a>, non-commercial use only`]
        })
        // The OL Map
        const map = new Map({
            target: mapRef.current,
            controls: defaultControls({ attribution: false }).extend([myAttribution]),
            layers: [
                new TileLayer({
                    source: source
                })
            ],
            view: new View({
                constrainResolution: true,
                center: fromLonLat([longitude, latitude]),
                zoom: 9
            })
        });

        // Add Icon with features to Map
        function addMapPoint(id, lat, lng, paddr, pdescr, pevent, pfile) {
            const myFeature = new Feature({
                geometry: new Point(transform([parseFloat(lng), parseFloat(lat)], 'EPSG:4326', 'EPSG:3857')),
                address: paddr,
                description: pdescr,
                event: pevent,
                id: id,
                file: pfile,
                fname: "icon"
            });
            const myStyle = new Style({
                image: new Icon({
                    src: mapIcon,
                    scale: 0.5,
                    anchor: [0.5, 1]
                })
            });
            myFeature.setStyle(myStyle);

            const myLayer = new VectorLayer({
                source: new Vector({
                    features: [myFeature]
                })
            });
            map.addLayer(myLayer);
        }
        // Click an Icon
        map.on("singleclick", e => {

            map.forEachFeatureAtPixel(e.pixel, feature => {
                let myF = {
                    address: feature.get("address"),
                    description: feature.get("description"),
                    event: feature.get("event"),
                    file: feature.get("file"),
                    id: feature.get("id"),
                    imgurl: feature.get("file")
                }
                poemFeatures.push(myF);
            });

            if (poemFeatures.length > 0) {
                setShow(true)
            }
        });

        // Get poems from Firebase
        async function fillMap() {
            const db = getFirestore(app);
            const myQuery = query(collection(db, "poems"));
            const querySnapshot = await getDocs(myQuery);
            querySnapshot.forEach(d => {
                addMapPoint(d.id, d.data().coords[0], d.data().coords[1], d.data().address, d.data().description, d.data().event, d.data().file);
            });
        }

        fillMap();

        return () => map.setTarget(null);
    }, [latitude, longitude, poemFeatures]);

    return (
        <>
            <div ref={mapRef} className="map" />
            <Modal show={show} onHide={() => { setShow(false); setFeatures([]) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {poemFeatures.length>1?<p>An diesem Ort gibt es mehrere Einträge:</p>:null}
                    {poemFeatures.map((feature, index) => (
                        <div key={feature.id}>
                            {poemFeatures.length>1?<h2>{index+1}</h2>:null}
                            <p>{feature.description}</p>
                            <Image src={feature.file?feature.file:null} className="greyscale poemPic" />
                            <p className="mt-3 ">Geeignet für: {feature.event}</p>
                            <p>Ort: {feature.address}</p>
                        </div>
                    ))}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default OlMap;